module.exports = __webpack_public_path__ + "static/media/tutorial.f7942403.mp4";